import {
  fetchGetUserDataByRequest,
  TGetUserDataByRequestResponse,
} from '../repositories/monolith-python/v1/get-user-data-by-request';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { TUser } from '../types/userData';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Ошибка при загрузке информации о пользователе';

interface IFetchUserParameters {
  subdomain: string;
  cookies?: string;
  /** Пробросить ошибку вместо возврата неавторизованного пользователя */
  throwOnError?: boolean;
}

export async function fetchUser(
  { httpApi, logger }: TContext,
  { subdomain, cookies, throwOnError = false }: IFetchUserParameters,
): Promise<TUser> {
  try {
    const userData: TGetUserDataByRequestResponse = await fetchGetUserDataByRequest({
      httpApi,
      parameters: {},
      config: {
        subdomain,
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (userData.statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.User,
        response: userData.response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode: userData.statusCode,
      });
    }

    return (userData.response.data.user || { isAuthenticated: false }) as TUser;
  } catch (ex) {
    const exception = getGenericLikeError({
      error: ex,
      domain: EExceptionDomain.User,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.warning(exception, {
      microserviceName: 'monolith-python',
      pathApi: '/cian-api/site/v1/get-user-data-by-request/',
    });

    if (throwOnError) {
      throw exception;
    }

    return { isAuthenticated: false } as TUser;
  }
}
